import { PaymentMethods } from '../../../../models'

const PAYMENT_METHOD_MAP: Record<string, number> = {
    check: PaymentMethods.Check,
    ach: PaymentMethods.ACH,
    credit_card: PaymentMethods.CreditCard,
    foreign_check: PaymentMethods.ForeignCheck,
    wire_transfer: PaymentMethods.Wire,
}

export function extractPaymentMethod(paymentMethod: string): string {
    const mapped = PAYMENT_METHOD_MAP[paymentMethod]

    return mapped !== undefined ? mapped.toString() : ''
}
